import React from 'react';
import { ContextualSaveBar, Layout, PageActions } from "@shopify/polaris";
import { CsI18n } from "../shared/csI18n/csI18n";
import Env from "../Env";

const CSPageActions = ({ validateError, saving, showSaveBar, handleSave, discardChanges, handleLoad }) => {
  let secondaryActions = [], saveBar;
  if (Env.isDevMode()) {
    secondaryActions.push({ content: 'Reload data', onAction: handleLoad });
  }
  if (showSaveBar) {
    saveBar = <ContextualSaveBar
      alignContentFlush
      message={validateError ? CsI18n.t('Unsaved changes. Please check error if any') : CsI18n.t('Unsaved changes')}
      saveAction={{ onAction: handleSave, loading: saving }}
      discardAction={{ onAction: discardChanges, loading: saving }}
    />;
  }

  return (
    <>
      <Layout>
        <Layout.Section>
          <PageActions
            secondaryActions={secondaryActions}
            primaryAction={{
              content: validateError ? CsI18n.t('Please correct errors before save') : CsI18n.t('Save'),
              onAction: handleSave,
              loading: saving
            }}
          />
        </Layout.Section>
      </Layout>

      {saveBar}
    </>
  )
}

export default CSPageActions;
